export default "__VITE_ASSET__H0JNGuYG__"